// This file should only contain action type constants.

export const SET_SOURCE_URL = 'SET_SOURCE_URL';
